export default "__VITE_ASSET__Df700IXg__"